/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaInputAddressPicker/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import Shortcut from 'DesignSystem/Shortcut/react'
import TysiaInputAddressPickerChoice from './TysiaInputAddressPickerChoice/index'
import styles from './view.module.css'
import useIsMedia from 'Simple/hooks/useIsMedia'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function TysiaInputAddressPicker({
  children,
  onChooseAddress,
  viewPath = "/DesignSystem/TysiaInput/TysiaInputAddressPicker",
  innerRef,
  from,
  left = 0,
  paddingLeft = 0,
  paddingRight = 0,
  selected,
  prevSuggestion,
  nextSuggestion,
  chooseSelectedAddress,
  closeSuggestions
  
}) {
  let isMedia = useIsMedia()
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceXl = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xl'
        })
  return (<React.Fragment
>
<div
  data-testid="TysiaInputAddressPicker.List"
  data-view-path={viewPath}
 ref={innerRef}
 style={{'--bc-1-1DDYo3': dtColorsWhite,'--bblr-2-1DDYo3': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bbrr-3-1DDYo3': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btlr-4-1DDYo3': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btrr-5-1DDYo3': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--l-6-1DDYo3': typeof left === 'number' ? `${left}px` : left,'--pb-7-1DDYo3': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pl-8-1DDYo3': typeof paddingLeft === 'number' ? `${paddingLeft}px` : paddingLeft,'--pr-9-1DDYo3': typeof paddingRight === 'number' ? `${paddingRight}px` : paddingRight,'--soy-10-1DDYo3': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--t-11-1DDYo3': typeof dtSpaceXl === 'number' ? `${dtSpaceXl}px` : dtSpaceXl,'--w-12-1DDYo3': isMedia.mobile ? "350px" : "360px"}}
 className={`views-block ${styles.List}`}
>
{Array.isArray(from) && from.map((item, index, list) => 
<ListItem
        key={item?.id ?? item?._id ?? index}
        context="tysia_input_address_picker_choice"
        item={item}
        index={index}
        list={list}
        hasItemKey={false}
        parentViewPath={viewPath}
        viewPath={`${viewPath}/TysiaInputAddressPickerChoice(${item?.id ?? item?._id ?? index})`}
      >
<TysiaInputAddressPickerChoice
 index={index} indexReverse={list.length - index} isFirst={index === 0} isLast={index === list.length - 1}
 item={item}
 viewPath={`${viewPath}/TysiaInputAddressPickerChoice(${item?.id ?? item?._id ?? index})`}
 onClick={onChooseAddress}
 selected={selected}
/>
</ListItem>
)}
</div>
<Shortcut
  viewPath={`${viewPath}/Shortcut`}
 keys="up"
 onPress={prevSuggestion}
/>
<Shortcut
  viewPath={`${viewPath}/Shortcut`}
 keys="down"
 onPress={nextSuggestion}
/>
<Shortcut
  viewPath={`${viewPath}/Shortcut`}
 keys="enter"
 onPress={chooseSelectedAddress}
/>
<Shortcut
  viewPath={`${viewPath}/Shortcut`}
 keys="esc"
 onPress={closeSuggestions}
/>
{children}
</React.Fragment>)
}

  function ListItem(props) {
    let valueItem = React.useMemo(() => ({
      index: props.index,
      indexReverse: props.list.length - props.index,
      isFirst: props.index === 0,
      isLast: props.index === props.list.length - 1,
    }), [props.index, props.list])
    
    
    
    return (
      <fromData.DataProvider
      context={props.context}
      value={props.item}
      
      
      viewPath={props.viewPath}
    >
      <fromData.DataProvider
        context={`${props.context}_item`}
        value={valueItem}
        viewPath={props.viewPath}
      >
        {props.children}
      </fromData.DataProvider>
    </fromData.DataProvider>
    )
  }